module.exports = __webpack_public_path__ + "static/media/hangman09.0610cd3e.svg";